(ns io.daskul.webapp.inbox
  "Pure, clock-free helpers for the recency inbox (SMS-36).

   No React / re-frame here — just `data -> value` derivations so they're
   unit-testable on the shared cljs harness (see inbox_test.cljs). Callers
   pass `now` in; nothing reads the wall clock.")

(def ^:private month-abbrevs
  ["Jan" "Feb" "Mar" "Apr" "May" "Jun"
   "Jul" "Aug" "Sep" "Oct" "Nov" "Dec"])

(defn- same-day?
  [^js a ^js b]
  (and (= (.getFullYear a) (.getFullYear b))
       (= (.getMonth a) (.getMonth b))
       (= (.getDate a) (.getDate b))))

(defn relative-time
  "Render `instant` (ISO string or js/Date) relative to `now` (js/Date),
   iMessage/WhatsApp style:

     <1h               → \"Nm\"      (e.g. \"2m\")
     earlier same day  → \"Nh\"      (e.g. \"3h\")
     previous day      → \"Yest.\"
     older             → \"MMM d\"   (e.g. \"May 22\")

   Clock-free: `now` is supplied by the caller. Returns nil for a nil/blank
   instant so a row with no last message simply shows no timestamp."
  [instant ^js now]
  (when (and instant (not= "" instant))
    (let [then     (js/Date. instant)
          diff-min (Math/floor (/ (- (.getTime now) (.getTime then)) 60000))
          yesterday (js/Date. (.getFullYear now) (.getMonth now)
                              (dec (.getDate now)))]
      (cond
        (< diff-min 60)        (str diff-min "m")
        (same-day? then now)   (str (Math/floor (/ diff-min 60)) "h")
        (same-day? then yesterday) "Yest."
        :else (str (nth month-abbrevs (.getMonth then)) " " (.getDate then))))))

(defn preview-text
  "Compose the inbox-row preview line. Outbound (admin/bot) replies get a
   \"You: \" prefix — matching the Option-B mockup — so the admin can tell at
   a glance whether the ball is in their court. Inbound previews are shown
   verbatim."
  [preview direction]
  (when preview
    (if (= "outbound" direction)
      (str "You: " preview)
      preview)))

(defn initials
  "Up to two uppercase initials from a sender name, for the avatar circle.
   Falls back to \"?\" when the name is blank/nil."
  [name]
  (let [parts (->> (when name (.split (.trim name) #"\s+"))
                   (remove #(= "" %)))]
    (if (seq parts)
      (->> parts
           (take 2)
           (map #(.toUpperCase (subs % 0 1)))
           (apply str))
      "?")))
